import { FEATURE_FLAGS } from '../config/featureFlags';

export const logApiAttempt = (message: string) => {
    if (!FEATURE_FLAGS.LOG) {
        console.log(message);
    }
};

export const debugLog = (message: string) => {
    console.log("🤖", message);
}